import { useRef } from 'react';
import PropTypes from 'prop-types';
import { Editor } from '@tinymce/tinymce-react';
import config from '../../config';

const MyEditor = ({
  initialValue = '',
  initHeight = 500,
  content,
  setContent,
  handleBlurBody,
  blurBody,
  disabled,
}) => {
  // Congelamos initialValue al montar. TinyMCE reinicializa el editor cuando
  // cambia esta prop entre renders, lo que provoca que el cursor vuelva al
  // inicio en cada tecla y el texto aparezca invertido.
  const initialValueRef = useRef(initialValue);

  const handleEditorChange = (text) => {
    setContent(text); // Actualiza el contenido en el estado
  };

  return (
    <>
      {content !== undefined ? (
        <div className={blurBody && content.length === 0 ? 'border border-danger error' : ''}>
          <Editor
            initialValue={initialValueRef.current}
            apiKey={config.REACT_APP_TINY}
            init={{
              branding: false,
              height: initHeight,
              menubar: true,
              plugins: [
                'table advlist autolink lists link image charmap print preview anchor',
                'searchreplace visualblocks code fullscreen',
                'insertdatetime media table paste code help wordcount',
                'link',
              ],
              toolbar:
                'undo redo | styleselect | bold italic | alignleft aligncenter alignright | code',
              language: 'es', // Configura el idioma a español
            }}
            onEditorChange={handleEditorChange}
            onBlur={handleBlurBody}
            disabled={disabled}
          />
        </div>
      ) : (
        ''
      )}
    </>
  );
};

MyEditor.propTypes = {
  initialValue: PropTypes.string,
  initHeight: PropTypes.number,
  content: PropTypes.string,
  setContent: PropTypes.func,
  blurBody: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  handleBlurBody: PropTypes.func,
  disabled: PropTypes.bool,
};

export default MyEditor;
